import { messaging } from "JS/Helpers/UserMessaging";
import { useCheckOnlineStatus } from "../Hooks/Media";
import { AppConfimationDialog } from "JS/React/Components/AppConfirmationDialog";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppButton } from "../Components/AppButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppTypography } from "../Components/AppTypography";
import { useResumeData } from "../Hooks/Firebase/Resume";
import { useEffect } from "react";

export interface NetworkModeManagerProps {
    onlineRoot: (isOnline: boolean) => React.ReactNode;
    offlineRoot: React.ReactNode;
}

const GoingOnlineBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1),
    background: theme.palette.background.grey200,
}));

const StyledGlobeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.colors.white,
    fontSize: "20px",
    marginRight: "10px",
}));

export const NetworkModeManager = (props: NetworkModeManagerProps) => {
    const { onlineRoot, offlineRoot } = props;
    const { isOnline, goingOffline, setIsOnline, goingOnline } =
        useCheckOnlineStatus();
    const {
        logAudioResume,
        logVideoResume,
        logPlaylistResume,
        logAudioBundleResume,
    } = useResumeData();

    useEffect(() => {
        if (goingOnline) {
            logAudioResume();
            logAudioBundleResume();
            logVideoResume();
            logPlaylistResume();
        }
    }, [goingOnline]);

    if (isOnline)
        return (
            <>
                {goingOffline && (
                    <AppConfimationDialog
                        open={goingOffline}
                        onClose={() => {
                            setIsOnline(false);
                        }}
                        titleSize="small"
                        popupMainText={messaging.networkMode.goingOffline}
                        cancelButtonText={messaging.networkMode.goOffline}
                    />
                )}
                {onlineRoot(isOnline)}
            </>
        );
    return (
        <>
            {goingOnline && (
                <GoingOnlineBox
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                >
                    <AppTypography textColor="black" variant="h6">
                        Internet is available
                    </AppTypography>
                    <AppButton
                        onClick={() => {
                            setIsOnline(true);
                        }}
                        color="primary"
                    >
                        <StyledGlobeIcon icon={["fas", "globe"]} />
                        Go Online
                    </AppButton>
                </GoingOnlineBox>
            )}
            {offlineRoot}
        </>
    );
};
